module.exports = __webpack_public_path__ + "img/gray-eye-icon.afc447f5.svg";